import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encrypt'
})
export class EncryptPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (args === 'desEncrypt') {
      return atob(value);
    } else if (args === 'encrypt') {
      return btoa(value);
    }
  }
}
